import { useLanderTemplates } from "../hooks/useLanderTemplates";
import LanderBreadcrumb from "./LanderBreadcrumb";
import { useLightningLanderContext } from "../providers/LightningLanderProvider";

function LanderTemplateBreadcrumbItem() {
    const { setTemplates } = useLanderTemplates();
    const { component, setComponent } = useLightningLanderContext()


    if (!component) {
        return <></>;
    }

    return (
        <LanderBreadcrumb
            component={component}
            setComponent={setComponent}
            setComponents={setTemplates}
        />
    );
}

export default LanderTemplateBreadcrumbItem;